import axios from "../services/api/api";
import { useQuery } from "@tanstack/react-query";

// SCHOOL QUERIES
const FetchSchoolsForAdmin = async () => {
  const res = await axios.get("/SchoolsForAdmin");
  return res.data.result;
};
export function GetSchoolsForAdmin() {
  return useQuery({
    queryKey: ["FetchSchoolsForAdmin"],
    queryFn: () => FetchSchoolsForAdmin(),
    retry: 3,
    refetchOnWindowFocus: false,
  });
}

const FetchSchoolTeachers = async (schoolId) => {
  const res = await axios.get(`/GetTeachersBySchoolId?schoolId=${schoolId}`);
  return res.data.result;
};
export function GetSchoolTeachers(schoolId) {
  return useQuery({
    queryKey: ["FetchSchoolTeachers", schoolId],
    queryFn: () => FetchSchoolTeachers(schoolId),
    retry: 3,
    refetchOnWindowFocus: false,
    enabled: !!schoolId,
  });
}

// CLASS QUERIES
const FetchClassesBySchoolId = async (schoolId) => {
  const res = await axios.get(`/Class/GetBySchoolId/${schoolId}`);
  return res.data.result;
};
export function GetClassesBySchoolId(schoolId) {
  return useQuery({
    queryKey: ["FetchClassesBySchoolId", schoolId],
    queryFn: () => FetchClassesBySchoolId(schoolId),
    retry: 3,
    refetchOnWindowFocus: false,
    enabled: !!schoolId,
  });
}

// MODULE QUERIES
const FetchModulesByCourseId = async (courseId) => {
  const res = await axios.get(`/Module/GetByCourseId?courseId=${courseId}`);
  return res.data.result;
};
export function GetModulesByCourseId(courseId) {
  return useQuery({
    queryKey: ["FetchModulesByCourseId", courseId],
    queryFn: () => FetchModulesByCourseId(courseId),
    retry: 3,
    refetchOnWindowFocus: false,
    enabled: !!courseId,
  });
}

const FetchAllModules = async () => {
  const res = await axios.get("/Module");
  return res.data.result;
};
export function GetAllModules() {
  return useQuery({
    queryKey: ["FetchAllModules"],
    queryFn: () => FetchAllModules(),
    retry: 3,
    refetchOnWindowFocus: false,
  });
}

const FetchValidLwFileNames = async () => {
  const res = await axios.get("/Module/GetValidLwFileNames");
  return res.data.result;
};
export function GetValidLwFileNames() {
  return useQuery({
    queryKey: ["FetchValidLwFileNames"],
    queryFn: () => FetchValidLwFileNames(),
    retry: 3,
    refetchOnWindowFocus: false,
  });
}

// ADMIN USER QUERIES
const FetchAdminUsers = async () => {
  const res = await axios.get("/user");
  return res.data.result;
};
export function GetAdminUsers() {
  return useQuery({
    queryKey: ["FetchAdminUsers"],
    queryFn: () => FetchAdminUsers(),
    retry: 3,
    refetchOnWindowFocus: false,
  });
}

// PROGRAMME QUERIES
const FetchProgrammesBySchoolId = async (schoolId) => {
  const res = await axios.get(`/programme/getBySchoolId/${schoolId}`);
  return res.data.result;
};
export function GetProgrammesBySchoolId(schoolId) {
  return useQuery({
    queryKey: ["FetchProgrammesBySchoolId", schoolId],
    queryFn: () => FetchProgrammesBySchoolId(schoolId),
    retry: 3,
    refetchOnWindowFocus: false,
    enabled: !!schoolId,
  });
}

const FetchFortnoxPrograms = async () => {
  const res = await axios.get("/programme/FortNoxPrograms");
  return res.data.result;
};
export function GetFortnoxPrograms() {
  return useQuery({
    queryKey: ["FetchFortnoxPrograms"],
    queryFn: () => FetchFortnoxPrograms(),
    retry: 3,
    refetchOnWindowFocus: false,
  });
}

// ORIENTATION QUERIES
const FetchOrientationsBySchoolId = async (schoolId) => {
  const res = await axios.get(`/orientation/getBySchoolId/${schoolId}`);
  return res.data.result;
};
export function GetOrientationsBySchoolId(schoolId) {
  return useQuery({
    queryKey: ["FetchOrientationsBySchoolId", schoolId],
    queryFn: () => FetchOrientationsBySchoolId(schoolId),
    retry: 3,
    refetchOnWindowFocus: false,
    enabled: !!schoolId,
  });
}

// COURSES LIST QUERIES
const FetchAdminCourses = async () => {
  const res = await axios.get("/Course/GetAdminCourses");
  return res.data.result;
};
export function GetAdminCourses() {
  return useQuery({
    queryKey: ["FetchAdminCourses"],
    queryFn: () => FetchAdminCourses(),
    retry: 3,
    refetchOnWindowFocus: false,
  });
}

const FetchAdminCoursesSlim = async () => {
  const res = await axios.get("/Course/GetAdminCoursesSlim");
  return res.data.result;
};
export function GetAdminCoursesSlim() {
  return useQuery({
    queryKey: ["FetchAdminCoursesSlim"],
    queryFn: () => FetchAdminCoursesSlim(),
    retry: 3,
    refetchOnWindowFocus: false,
  });
}

const FetchOrphanCourses = async () => {
  const res = await axios.get("/Course/GetAdminOrphanCourses");
  return res.data.result;
};
export function GetOrphanCourses() {
  return useQuery({
    queryKey: ["FetchOrphanCourses"],
    queryFn: () => FetchOrphanCourses(),
    retry: 3,
    refetchOnWindowFocus: false,
  });
}

// INVOICE QUERIES
const FetchInvoiceHistoryForAllCustomers = async () => {
  const res = await axios.get("/Shop/GetAll");
  return res.data.result;
};
export function GetInvoiceHistoryForAllCustomers() {
  return useQuery({
    queryKey: ["FetchInvoiceHistoryForAllCustomers"],
    queryFn: () => FetchInvoiceHistoryForAllCustomers(),
    retry: 3,
    refetchOnWindowFocus: false,
  });
}

// PROGRAM LICENSE QUERIES
const FetchAvailableProgramLicenses = async () => {
  const res = await axios.get("/ProgramLicense/GetAvailableProgramLicenses");
  return res.data.result;
};
export function GetAvailableProgramLicenses() {
  return useQuery({
    queryKey: ["FetchAvailableProgramLicenses"],
    queryFn: () => FetchAvailableProgramLicenses(),
    retry: 3,
    refetchOnWindowFocus: false,
  });
}

const FetchCustomerProgramLicenses = async (customerId) => {
  const res = await axios.get(
    `/ProgramLicense/GetByCustomer?customerId=${customerId}`,
  );
  return res.data.result;
};
export function GetCustomerProgramLicenses(customerId) {
  return useQuery({
    queryKey: ["FetchCustomerProgramLicenses", customerId],
    queryFn: () => FetchCustomerProgramLicenses(customerId),
    retry: 3,
    refetchOnWindowFocus: false,
    enabled: !!customerId,
  });
}

// PRODUCTS/LICENSE SHOP QUERIES
const FetchShopLicenses = async (schoolId) => {
  const res = await axios.get(`/ShopNew/GetLicenses?schoolId=${schoolId}`);
  return res.data.result;
};
export function GetShopLicenses(schoolId) {
  return useQuery({
    queryKey: ["FetchShopLicenses", schoolId],
    queryFn: () => FetchShopLicenses(schoolId),
    retry: 3,
    refetchOnWindowFocus: false,
    enabled: !!schoolId,
  });
}

const FetchStudentsWithLicense = async (schoolId) => {
  const res = await axios.get(
    `/ShopNew/LicenseStatusForStudents?schoolId=${schoolId}`,
  );
  return res.data.result;
};
export function GetStudentsWithLicense(schoolId) {
  return useQuery({
    queryKey: ["FetchStudentsWithLicense", schoolId],
    queryFn: () => FetchStudentsWithLicense(schoolId),
    retry: 3,
    refetchOnWindowFocus: false,
    enabled: !!schoolId,
  });
}

// NOTIFICATIONS QUERIES
const FetchNotifications = async () => {
  const res = await axios.get("/User/GetNotices");
  return res.data.result;
};
export function GetNotifications(opt = {}) {
  return useQuery({
    queryKey: ["FetchNotifications"],
    queryFn: () => FetchNotifications(),
    retry: 3,
    refetchOnWindowFocus: false,
    ...opt,
  });
}

// RATINGS QUERIES
const FetchCourseGrades = async (showOnlyLastSixMonths) => {
  const res = await axios.get(
    `/Course/GetStudentScormModuleRatings?showOnlyLastSixMonths=${showOnlyLastSixMonths}`,
  );
  return res.data.result;
};
export function GetCourseGrades(showOnlyLastSixMonths = true) {
  return useQuery({
    queryKey: ["FetchCourseGrades", showOnlyLastSixMonths],
    queryFn: () => FetchCourseGrades(showOnlyLastSixMonths),
    retry: 3,
    refetchOnWindowFocus: false,
  });
}
